module.exports = __webpack_public_path__ + "img/chekuangLogo.188967a4.png";